import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import api from "../../../../../../services/api";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import Form from './Form'
import {
  Button,
  ButtonGroup,
  Row,
  Col,
  Modal,
} from "reactstrap";

export default ({ notify, empresa, setHeaderContent, isActive, ...props }) => {

  const [tipoProdutos, setTipoProdutos] = useState([])
  const [situacao, setSituacao] = useState('A')

  const situacoes = [
    { id: '', text: 'Todos' },
    { id: 'A', text: 'Ativos' },
    { id: 'I', text: 'Inativos' },
  ]

  const [showModal, setShowModal] = useState(false)
  const [tipoProdutoSelecionado, setTipoProdutoSelecionado] = useState(null)
  const [columns, setColumns] = useState([
    {
      dataField: 'acoes',
      formatter: (cell, row) => acoesFormatter(cell, row)
    },
    {
      dataField: 'nome',
      text: 'Nome',
      sort: true
    },
    {
      dataField: 'situacao',
      text: 'Situação',
      sort: true,
      formatter: (cell, row) => row.situacao == 'A' ? 'Ativo' : 'Inativo',
      align: 'center',
      headerAlign: 'center'
    },
  ])

  useEffect(() => {
    if (tipoProdutos.length === 0) loadTipoProdutos()
  }, [])

  useEffect(() => {
    if (isActive && setHeaderContent) {
      setHeaderContent(
        <div className="d-flex justify-content-between align-items-center w-100">
          <h1 className="mb-0">Produtos</h1>
          <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            <ButtonGroup
              className="btn-group-toggle"
              size="sm"
              data-toggle="buttons"
            >
              {situacoes.map((item, key) => (
                <Button
                  key={key}
                  className={classnames({ active: situacao === item.id })}
                  color="secondary"
                  onClick={() => setSituacao(item.id)}
                >
                  {item.text}
                </Button>
              ))}
            </ButtonGroup>
            <Button
              color="primary"
              type="button"
              className="btn-icon btn-3"
              size="sm"
              onClick={() => setShowModal(true)}
              style={{ height: "32px" }}
            >
              <span className="btn-inner--icon">
                <i className="ni ni-fat-add"></i>
              </span>
              <span className="btn-inner--text">Novo Tipo Produto</span>
            </Button>
          </div>
        </div>
      );
    }
  }, [isActive, setHeaderContent, situacao]);

  useEffect(() => {
    if (!showModal) {
      setTipoProdutoSelecionado(null)
    }
  }, [showModal])

  function acoesFormatter(cell, row) {
    return (<>
      <div class="btn-group" role="group" aria-label="Basic example">
        <Button
          className="btn-sm"
          color="secondary"
          onClick={() => edit(row.id)}
          outline>
          <i class="far fa-edit"></i>
        </Button>
      </div>
    </>)
  }

  function edit(tipoProdutoId) {
    setTipoProdutoSelecionado(tipoProdutoId)
    setShowModal(true)
  }

  const dateFormater = (date) => {
    return new Date(date).toLocaleDateString('pt-br', { year: 'numeric', month: 'short', day: 'numeric' })
  }

  function handleSaveTipoProduto() {
    notify('success', 'Tipo produto salvo')
    loadTipoProdutos()
    setShowModal(false)
  }

  async function loadTipoProdutos() {
    try {
      const response = await api.get(`/common/empresas/${empresa.id}/tipos-produtos`)
      if (response.data) {
        setTipoProdutos(response.data)
      }
    } catch (error) {
      console.log(error)
      notify('danger', 'Não foi possível carregar tipos de produtos')
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'center'
        }}
      >
        {/* Removed local Novo button, now in parent header */}
        <Modal
          className="modal-dialog-centered"
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
        >
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {tipoProdutoSelecionado ? 'Alterar Tipo Produto' : 'Novo Tipo Produto'}
            </h5>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setShowModal(!showModal)}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              notify={notify}
              tipoProdutoId={tipoProdutoSelecionado}
              onSuccess={handleSaveTipoProduto}
              close={() => setShowModal(false)}
              empresaId={empresa.id}
            />
          </div>
        </Modal>
      </div>
      <Row>
        <Col>
          <ToolkitProvider
            data={situacao ? tipoProdutos.filter(tp => tp.situacao === situacao) : tipoProdutos}
            keyField="nome"
            columns={columns}
            search
          >
            {props => (
              <div className="py-4">
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                  classes="table-sm table-v-middle"
                  condensed
                />
              </div>
            )}
          </ToolkitProvider>
        </Col>
      </Row>
    </>
  );
}
